<div>
	<h1 class="h2 mb-4">{{'nav.iccid_changes_report' | translate}}</h1>
	<sct-custom-table
		[columnsConfig]="columnConfig"
		[data]="tableData"
		[config]="tableConfig"
	></sct-custom-table>
</div>
